import { render, staticRenderFns } from "./ivyContent.vue?vue&type=template&id=dadda13a&"
import script from "./ivyContent.vue?vue&type=script&lang=js&"
export * from "./ivyContent.vue?vue&type=script&lang=js&"
import style0 from "./ivyContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports